import Service from '../service';

export default class ContactService extends Service {
  baseApi = '/user/contacts';

  async getContacts(query) {
    const url = `${this.baseApi}`;
    return await this.getResource(url, query);
  }

  async createContact(data) {
    const url = `${this.baseApi}`;
    return await this.postResource(url, data);
  }

  async updateContact(id, data) {
    const url = `${this.baseApi}/${id}`;
    return await this.putResource(url, data);
  }

  async deleteContact(id) {
    const url = `${this.baseApi}/${id}`;
    return await this.deleteResource(url);
  }
}
